import { FETCH_IMAGE_ASYNC, RUN_VISUAL_SCAN_ASYNC } from './constants'

export const runScan = (data) => ({
  type: RUN_VISUAL_SCAN_ASYNC.INITIATE,
  payload: { data },
})
export const runScanSuccess = (data) => ({
  type: RUN_VISUAL_SCAN_ASYNC.SUCCESS,
  payload: { data },
})
export const runScanError = (error) => ({
  type: RUN_VISUAL_SCAN_ASYNC.ERROR,
  error,
})

export const fetchImage = (data) => ({
  type: FETCH_IMAGE_ASYNC.INITIATE,
  payload: { data },
})
export const fetchImageSuccess = (data) => ({
  type: FETCH_IMAGE_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchImageError = (error) => ({
  type: FETCH_IMAGE_ASYNC.ERROR,
  payload: { error },
})

export default {
  // to props
  runScan,
  runScanSuccess,
  runScanError,
  fetchImage,
  fetchImageSuccess,
  fetchImageError,
}
